import React from "react";
import LocationIcon from "@mui/icons-material/LocationOn";
import { AlertInformation } from "./AlertInformation/AlertInformation";

export type CurrentLocationBayAlertProps = {
    currentLocation?: string
}

/**
 * Displays a message styled as an alert displaying the inbound location that stock is currently being assigned to. 
 *
 * This feature is used by staff working in fulfilment centres. When receiving stock they store the product in a warehouse
 * location. Referred to as an inbound location or put away location, is a physical space where stock is stored within
 * the warehouse.
 *
 * @component
 * @param {CurrentLocationBayAlertProps} props - The props object for this component. Contains the current location.
 */
const CurrentLocationBayAlert: React.FC<CurrentLocationBayAlertProps> = ({
    currentLocation
}: CurrentLocationBayAlertProps) =>
    (
        currentLocation ? (
            <AlertInformation
                icon={<LocationIcon/>}
                severity="warning"
                title={`Currently assigning to ${currentLocation}`}
                message="To stop assigning to this location, enter a new one"
            />
        ) : (
            <></>
        )
    )

export default CurrentLocationBayAlert;